module.exports = __webpack_public_path__ + "static/media/Completed.9ecf3e2d.png";